import React from 'react';
import ToolbarButton from '@plone/volto-slate/editor/ui/ToolbarButton';
import { Editor, Element, Transforms } from 'slate';
import { useSlate } from 'slate-react';

// Editor.isBlock só verifica "!isInline"; sem checar Element.isElement ela
// também é verdadeira para nós de texto, então o "lowest" match pega o texto
// em vez do parágrafo.
const getBlockEntries = (editor, selection) =>
  selection
    ? Array.from(
        Editor.nodes(editor, {
          at: selection,
          match: (node) =>
            Element.isElement(node) && Editor.isBlock(editor, node),
          mode: 'lowest',
        }),
      )
    : [];

const TextAlignButton = ({ alignment, icon, title }) => {
  const editor = useSlate();
  const selection = editor.selection || editor.getSavedSelection?.();
  const blocks = getBlockEntries(editor, selection);
  const isLeft = alignment === 'left';
  const active = isLeft
    ? blocks.length > 0 &&
      blocks.every(([node]) => !node.textAlign || node.textAlign === 'left')
    : blocks.length > 0 &&
      blocks.every(([node]) => node.textAlign === alignment);

  const handleMouseDown = React.useCallback(
    (event) => {
      event.preventDefault();
      const currentSelection = editor.selection || editor.getSavedSelection?.();
      if (!currentSelection) return;

      const blockEntries = getBlockEntries(editor, currentSelection);
      const isActive = isLeft
        ? blockEntries.length > 0 &&
          blockEntries.every(
            ([node]) => !node.textAlign || node.textAlign === 'left',
          )
        : blockEntries.length > 0 &&
          blockEntries.every(([node]) => node.textAlign === alignment);

      if (isLeft) {
        blockEntries.forEach(([, path]) => {
          Transforms.unsetNodes(editor, 'textAlign', { at: path });
        });
      } else {
        blockEntries.forEach(([, path]) => {
          if (isActive) {
            Transforms.unsetNodes(editor, 'textAlign', { at: path });
          } else {
            Transforms.setNodes(editor, { textAlign: alignment }, { at: path });
          }
        });
      }
    },
    [alignment, editor, isLeft],
  );

  return (
    <ToolbarButton
      title={title}
      icon={icon}
      active={active}
      onMouseDown={handleMouseDown}
    />
  );
};

export default TextAlignButton;
